if (!customElements.get("media-gallery-with-vertical-slider")) {
  customElements.define(
    "media-gallery-with-vertical-slider",
    class MediaGalleryWithVerticalSlider extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          verticalThumbnails: this.querySelector('[id^="GalleryVerticalThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        this.setupVideoAutoplay();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        [this.elements.thumbnails, this.elements.verticalThumbnails].forEach(thumbnails => {
          thumbnails.querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        });
        if (this.dataset.desktopLayout !== "stacked" && this.mql.matches)
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        // Custom: Play media when scrolling through the gallery
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        this.playActiveMedia(activeMedia);

        // Set active thumbnail when scrolling through the gallery
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        const verticalThumbnail = this.elements.verticalThumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.setActiveVerticalThumbnail(verticalThumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );

        if (!this.elements.thumbnails) return;
        const activeVerticalThumbnail = this.elements.verticalThumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveVerticalThumbnail(activeVerticalThumbnail);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      setActiveVerticalThumbnail(thumbnail) {
        if (!this.elements.verticalThumbnails || !thumbnail) return;

        this.elements.verticalThumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.verticalThumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.verticalThumbnails.slider.scrollTo({
          top: thumbnail.offsetTop,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      setupVideoAutoplay() {
        const isMobile = !this.mql.matches;
        const videoSlides = this.querySelectorAll('[data-media-type="video"]');
        if (!videoSlides.length) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (isMobile) {
              const video = entry.target.querySelector('.product__video-mobile video');
              if (!video) return;
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            } else {
              const deferredMedia = entry.target.querySelector('deferred-media');
              if (!deferredMedia) return;
              if (entry.isIntersecting) {
                deferredMedia.loadContent(false);
                const video = deferredMedia.querySelector('video');
                if (video) video.play();
              } else {
                const video = deferredMedia.querySelector('video');
                if (video && !video.paused) video.pause();
              }
            }
          });
        }, { threshold: 0.5 });
        videoSlides.forEach((slide) => observer.observe(slide));
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
